import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0acc9051"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "font-bold" }, "Må behandles og lukkes innen", -1))
const _hoisted_3 = {
  key: 0,
  class: "field-error"
}

import dayjs from 'dayjs';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'RfpDeadline',
  props: {
    mode: {},
    error: {},
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {

const props = __props;




const value = computed({
  get: () => props.modelValue,
  set: (v) => {
    emit("update:modelValue", v);
  },
});

const date_formatted = computed(() => {
  return dayjs(props.modelValue).format("DD.MM.YYYY");
});

return (_ctx: any,_cache: any) => {
  return (_ctx.modelValue || _ctx.mode === 'edit')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        (_ctx.mode === 'view')
          ? (_openBlock(), _createElementBlock("p", {
              key: 0,
              class: _normalizeClass({
        'text-red-600 font-bold': _unref(dayjs)(_ctx.modelValue).isBefore(),
      })
            }, _toDisplayString(date_formatted.value), 3))
          : (_ctx.mode === 'edit')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  class: "w-full",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event))
                }, null, 512), [
                  [_vModelText, value.value]
                ]),
                (_ctx.error)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.error), 1))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})